/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientPharmaciesViewModel } from './PatientPharmaciesViewModel'; 

export function getPatientPharmaciesOptions(stayId: string, onSuccess?: (result: PatientPharmaciesViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-pharmacies', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/medicationprofiles/queries/getpatientpharmacies/' + stayId;
			const resp = await axios.get<PatientPharmaciesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}